import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class FeatureRequestModel extends BaseModel {
  title = null;
  description = null;
  module_name = null;
  priority = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    title: 'required|max:255',
    description: 'required',
    priority: 'required'
  };

  attributeHints = {
  };

  attributeLabels = {
    title: i18n.t('Title'),
    description: i18n.t('Description'),
    module_name: i18n.t('Module'),
    priority: i18n.t('Priority'),
  };
}
